<template>
<div style="margin-top: 20px;">
  <loading :active.sync="isLoading"
    :can-cancel="true"
    color="#5bad2b"
    :is-full-page="fullPage"></loading>
  <div v-show="intestpoput" class="modal fade1 in" id="modal-default" style="overflow: auto;display: block; padding-right: 17px;">
          <div class="modal-dialog">
            <div class="modal-content" style="width: 525px !important;">
              <div class="modal-header" style="padding: 6px !important;">
                <button @click="close()" type="button" data-dismiss="modal" aria-label="Close" class="close mt-2"><i aria-hidden="true" class="uil uil-times"></i></button>
                <h4 class="modal-title" v-if="reschedule_type == 'normal'">Re-Schedule</h4>
                <h4 class="modal-title" v-if="reschedule_type != 'normal'">Schedule</h4>
              </div>
              <div class="modal-body" style="height: auto !important;overflow:auto;background-color: white;">
                <div class="row">
                  <div class="col-md-12">
                      <div class="col-md-5">
                        <h5>Schedule date & time </h5>
                      </div>
                      <div class="col-md-7">
                        <a style="line-height: 2.5;" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right"><i class="fa fa-clock-o" aria-hidden="true"></i> {{sheduledatas.start_datetime | time}} - {{sheduledatas.end_datetime | time}}</a>
                        <div class="pull-right with-date" style="width: 40%;">
                          <span>{{sheduledatas.schedule_date | formatDate}}</span><br>
                          <span>{{sheduledatas.schedule_date | getDay}}</span>
                        </div>
                      </div>
                    </div>
                <b-form class="register-form" v-on:submit.prevent="reSchedule" novalidate>
                  <div class="form-group" v-if="reschedule_type == 'normal'">
                  <label for="inputEmail3" class="col-sm-2 control-label">Reason</label>
                  <div class="col-sm-10" style="margin-bottom: 10px;">
                    <div class="form-group" style="margin-top:10px;">
                        <div class="form-select">
                          <select id="reason" v-model="form.reason" class="form-control is-valid" v-bind:class="{ 'is-invalid': !chkState('reason') }">
                            <option value=''>Select the reason *</option>
                            <option v-for="(x, index) in reasonList" v-bind:value="x._id" :key="index">{{x.value}}</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div v-if="$v.form.reason.$error">
                          <p v-if="!$v.form.reason.required" class="login-alert-msg error-content">* Select the reason</p>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="form-group" v-if="reschedule_type == 'normal'">
                  <label for="inputPassword3" class="col-sm-2 control-label">Comments</label>
                  <div class="col-sm-10">
                      <b-form-textarea v-model.lazy.trim="$v.form.comments.$model" :state="chkState('comments')" v-bind:class="{ 'is-invalid': !chkState('comments') }"  class="textarea" rows="5" placeholder="Enter comments*"></b-form-textarea>
                      <div v-if="$v.form.comments.$error">
                        <p v-if="!$v.form.comments.required" class="login-alert-msg error-content">* Enter the comments</p>
                      </div>
                  </div>
                </div>
                  <div class="row">
                      <div class="col-md-12" v-if="groupeddate.length > 0">
                        <h5>Select Re-schedule date & time</h5>
                      </div>
                      <div class="col-md-12" v-if="groupeddate.length < 1">
                        <h5 class="tc" style="color:#aaa8a8;padding: 15px;">Interviewer has no available time!</h5>
                      </div>
                      <div class="col-md-12">
                        <ul class="donate-now mt-0">
                          <li v-for="(date, index) in groupeddate" :key="index" @click="changeDate(date.startdate)">
                            <input type="radio" :id="date._id" name="date" />
                            <label :for="date._id">{{date.startdate}} <br> {{date.startday}}</label>
                          </li>
                        </ul>
                      </div>
                      <div v-if="showre_date_error">
                        <p class="login-alert-msg error-content ml-5">* Select the date</p>
                      </div>
                  <div class="col-md-12 mt-2 ml8" v-if="showtime">
                      Select time1
                      <hr>
                  </div>
                  <div class="col-md-12" v-if="showtime">
                      <ul class="donate-now mt-0">
                        <li v-for="(date, index) in availabletime" :key="index" style="width: 143px;height: 33px;" class="mb-2" @click="getdatetime(date,date.end_datetime)">
                          <input type="radio" :id="date.start_datetime" name="time" />
                          <label :for="date.start_datetime"><i class="fa fa-clock-o" aria-hidden="true"></i> {{date.start_time}} - {{date.end_time}}</label>
                        </li>
                      </ul>
                  </div>
                  <div v-if="showre_time_error">
                    <p class="login-alert-msg error-content">* Select the time</p>
                  </div>
                <div v-if="validationerror" class="scroll-to-me mt-1" style="color:red;margin-left: -10px;">* Please select availability time</div>
                </div>
                <hr style="margin-top:10px">
              <button :disabled="groupeddate.length < 1" type="submit"  class="btn btn-success pull-right" style="margin-top: 5px;
    margin-bottom: 5px;">Submit</button>
              </b-form>
                </div>
                </div>
            </div>
              </div>
            </div>
            <!-- /.modal-content -->
          <!-- /.modal-dialog -->
      <div class="col-md-12" style="margin-top: 20px;margin-bottom: 25px;">
          <!-- Custom Tabs -->
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li v-on:click="navigation('Post')"><a href="#tab_1" data-toggle="tab">Post</a></li>
              <li v-on:click="navigation('To-be-Scheduled')"><a href="#tab_2" data-toggle="tab">To-be Scheduled</a></li>
              <li class="active" v-on:click="navigation('Scheduled')"><a href="#tab_3" data-toggle="tab">Scheduled</a></li>
              <li v-on:click="navigation('Result')"><a href="#tab_4" data-toggle="tab">Result</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
              <div class="col-md-6 remove-pad">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h3 class="box-title">Scheduled</h3>
                  </div>
                  <div class="box-header with-border">
                    <input type="text" class="form-control pull-left search-text" placeholder="Search" style="width:50%;height: 20% !important;">
                    <div style="width:50%;" class="pull-right">
                      <div class="form-group">
                        <div class="form-select pull-right" style="width: 50%;">
                          <select class="form-control input-sm" v-model="postsort" @change="getDatas()">
                            <option value="7">Last 7 days</option>
                            <option value="30">Last 30 days</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div>
                      <span class="pull-right ml-1" style="margin-top: -5px;">Sort by</span>
                    </div>
                  </div>
                  <!-- /.box-header -->
                  <div class="box-body scroll-manual">
                    <div style="text-align:center; margin-top:30%" v-if="datas.length < 1">
                      <img src="../../assets/img/scheduled_empty.svg" alt="Product Image" style="width: 150px;">
                      <br>
                      <!-- <span style="font-size: 12px;">No data found</span> -->
                    </div>
                    <ul class="products-list product-list-in-box">
                        <div style="margin-top:30px;text-align:center" v-if="datas.length < 1"> No data found</div>

                       <li class="item" v-for="(x, index) in datas" :key="index" @click="getReleventProfile(x._id, x)" v-bind:class="{'active': selectpost === x._id}">
                          <div class="row">
                         <div class="col-md-5 p-1">
                           <div class="product-img">
                            <img v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="img-circle">
                            <img v-if="x.profile_picture =='' || x.profile_picture ==null" src="../../assets/img/org-default.png" class="img-circle">
                            <img v-if="x.post_expired =='true'" src="../../assets/img/expired.png" class="img-circle exp-img mt-2" style="width: 13px !important;margin-left:-9px;height: 13px !important;">
                          </div>
                          <div class="product-info">
                            <a href="javascript:void(0)" class="product-title">{{x.job_tittle}} <img v-if="x.notification_count > 0" src="../../assets/img/green_dot.svg" class="img-circle">
                            </a>
                            <span class="product-description" :title="x.post_unique_id"><span class="skill-lable">{{x.post_unique_id}}</span></span>
                          </div>
                         </div>
                         <div class="col-md-7 p-1">
                            <div class="pull-right showdate">
                              <span class="ml-1">Posted on : {{x.created_at | formatDate}}</span>
                              <!-- <span>Validity : {{x.post_validity | formatDate}}</span> -->
                            </div>
                          </div>
                          <div class="col-md-7 showdate1">
                            <span class="pull-right" v-if="x.isclient =='yes'">Created by : {{x.created_by_name}}</span>
                          </div>
                         </div>
                         <div class="row">
                          <div class="col-md-5 p-1">
                            <div class="ml-5 mt-2">
                            <span class="product-description" :title="x.primaryskillnames"><span class="skill-lable">Skills</span>
                              {{x.primaryskillnames}}
                            </span>
                          </div>
                          </div>
                          <div class="col-md-7 p-1">
                            <div class="btn-group pull-right">
                              <button type="button" class="btn bg-full btn-sm"><i class="fa fa-calendar" aria-hidden="true"></i> Scheduled</button>
                              <button type="button" class="btn btn-default btn-sm b-c ml-1">{{x.schedulecount}}</button>
                            </div>
                          </div>
                         </div>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-6 remove-pad">
                <div class="box box-primary">
                  <div class="box-header with-border" v-if="datas.length > 0 && selectdata">
                    <div class="direct-chat-msg">
                      <div class="clearfix">
                        <span class="direct-chat-name pull-left" v-if="selectdata.job_tittle">{{selectdata.job_tittle}}</span>
                      </div>
                    </div>
                    <div class="direct-chat-msg">
                      <span class="direct-chat-timestamp pull-left">{{selectdata.post_unique_id}} <span class="ml-20" v-if="selectdata.post_expired =='true'"><img src="../../assets/img/expired.png" class="img-circle exp-img" style="width: 13px !important;margin-top:2px;height: 13px !important;"> <span class="expired">Expired</span></span></span>
                    </div>
                    <div class="direct-chat-msg">
                      <span class="direct-chat-timestamp pull-left" v-if="selectdata.primaryskillnames">Skills <span style="color:black"> {{selectdata.primaryskillnames}}</span></span>
                      <span class="direct-chat-timestamp pull-right" v-if="selectdata.post_validity">Validity : {{selectdata.post_validity | formatDate}}</span>
                    </div>
                  </div>
                  <div class="box box-primary" v-if="datas.length > 0 && selectdata">
                    <div class="box-header with-border">
                      <span class="direct-chat-name">Scheduled</span>
                      <div class="box-tools pull-right">
                        <span>Sort by: </span>
                        <button type="button" class="btn btn-box-tool" data-widget="collapse">Timings <i class="fa fa-long-arrow-up" aria-hidden="true"></i><i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-box-tool" data-widget="remove">Price <i class="fa fa-long-arrow-up" aria-hidden="true"></i><i class="fa fa-long-arrow-down" aria-hidden="true"></i></button>
                      </div>
                    </div>
                  </div>
                  <!-- /.box-header -->
                  <div style="margin-top:50%;text-align:center" v-if="releventprofileslength < 1">
                      <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                  </div>
                  <CardView @getavailabledate="getavailabledateEmit" :selectdata="selectdata" :schedule="true" :data="releventprofiles" :showRole="showRole" :currentTimezone="currentTimezone" :selectpost="selectpost"></CardView>
                  <!-- <div class="direct-chat-messages" v-for="(x, index) in releventprofiles" :key="index">
                    <div class="direct-chat-msg" style="cursor:pointer;">
                       <img @click="showModal(x._id)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../../assets/img/default.png" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../../assets/img/female_default.png" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../../assets/img/male_default.png" class="direct-chat-img">
                      <div class="direct-chat-info clearfix">
                        <span class="direct-chat-name pull-left ml8 name" @click="showModal(x.user_id)">{{x.first_name}} {{x.last_name}}<br>
                          <span style="color:#999;font-weight: 400;">Applied on : {{x.interviewer_interest_date | formatDatetimea }}</span>
                        </span>
                        <span @click="showShedule(x._id,x.user_id)" class="direct-chat-timestamp pull-right" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="Boolean('false')" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" :read-only="true"></star-rating></span>
                        <button v-if="!Boolean(showRole)" @click="showShedule(x._id,x.user_id)" class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                      </div>
                      <div class="direct-chat-info clearfix" @click="showShedule(x._id,x.user_id)">
                        <span class="direct-chat-timestamp pull-left">Candidate Name : <span style="color:black"> {{x.candidate_name}} {{x.candidate_lastname}}</span></span>
                        <span class="direct-chat-timestamp pull-right" style="width:27%;color: #60AB2F;"><i class="fa fa-clock-o" aria-hidden="true"></i> {{getTime(x.startdatetime_utc)}} to {{ getTime(x.enddatetime_utc)}} {{currentTimezone}} </span>
                        <span class="direct-chat-timestamp pull-right" style="width:20%;color: #60AB2F;"><i class="fa fa-calendar" aria-hidden="true"></i> {{getDate(x.startdatetime_utc)}}</span>
                      </div>
                      <div class="direct-chat-info clearfix">
                      <span @click="showShedule(x._id,x.user_id)" v-if="x.status == 'Reschedule Request Pending'" class="direct-chat-timestamp pull-left requested-pending-l"> Reschedule Request Pending</span>
                      <span @click="showShedule(x._id,x.user_id)" v-if="x.reschedule_by !=null && x.status =='Reschedule Requested' && x.req_new_time =='interviewer'" class="direct-chat-timestamp pull-left requested-l" style="color:#563CFF;background-color:#F9ECFF;"> Requested New Time</span>
                      <span @click="showShedule(x._id,x.user_id)" v-if="x.status =='Reschedule Requested' && x.req_new_time !='interviewer'" class="direct-chat-timestamp pull-left requested-l"> Reschedule Requested</span>
                      <span @click="showShedule(x._id,x.user_id)" v-if="x.status =='Schedule Request'" class="direct-chat-timestamp pull-left requested-l" style="color:#67E91A;background-color:#F2FEEB;"> Schedule Request Pending</span>
                      <span v-if="selectdata.isclient =='no' && x.status == 'Reschedule Requested' && x.reschedule_by ==null && x.req_new_time =='interviewer'" class="direct-chat-timestamp pull-left requested-l" style="color:#67E91A;background-color:#F2FEEB;"> New Time Requested </span>
                        <div>
                          <button :disabled="checkingdate(x.startdatetime_utc, x.enddatetime_utc) == 'no'" v-if="x.status == 'Open' && selectdata.isclient =='no'" class="btn connectbtn btn-sm pull-right" @click="connect(x.meeting_id,x._id,x.user_id, x)"> Connect</button>
                          <button v-if="selectdata.isclient =='no' && x.status == 'Reschedule Requested' && x.req_new_time !='interviewer'" class="btn sbtn btn-sm pull-right" @click="getavailabledate(x.user_id,x)">Schedule</button>
                          <button v-if="selectdata.isclient =='no' && x.status == 'Reschedule Requested' && x.reschedule_by !=null && x.req_new_time =='interviewer'" @click="getavailabledate(x.user_id,x)" class="btn sbtn btn-sm pull-right">Schedule</button>
                          <button v-if="selectdata.isclient =='no' && x.status == 'Reschedule Requested' && x.reschedule_by ==null && x.req_new_time =='interviewer'" @click="getavailabledate(x.user_id,x)" class="btn sbtn btn-sm pull-right">Schedule</button>
                          <span v-if="x.status == 'Cancelled'" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;background-color:#F5F5F5;padding:0 6px;border-radius:12px;"> Cancelled</span>
                          <span v-if="x.status == 'Declined'" @click="openInfo(x)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;background-color:#F5F5F5;padding:0 6px;border-radius:12px;"> Declined</span>
                          <span v-if="x.status == 'Auto-Declined'" @click="openInfo(x)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;background-color:#F5F5F5;padding:0 6px;border-radius:12px;"> Auto Declined</span>
                          <span v-if="x.status == 'Expired'" class="direct-chat-timestamp pull-right mt-2" style="color:#fff;margin-right: 10px;background-color:#E74E4E;padding:0 6px;border-radius:12px;"> Expired</span>
                          <span v-if="x.status == 'Accepted'" @click="openInfo(x)" class="direct-chat-timestamp pull-right mt-2" style="color:#fff;margin-right: 10px;background-color:rgb(96 171 47);padding:0 6px;border-radius:12px;"> Accepted</span>
                        </div>
                        <div v-if="selectdata.isclient =='no'">
                          <span v-if="x.status == 'Open' && x.reschedule_by ==null && x.req_new_time !='interviewer'" @click="getavailabledate(x.user_id,x)" class="direct-chat-timestamp pull-right mt-2" style="color:#60ab2f;margin-right: 10px;cursor:pointer;"><i class="fa fa-history" aria-hidden="true"></i> Reschedule</span>
                          <span v-if="x.status == 'Open' || x.status == 'Accepted' || x.status =='Schedule Request'" @click="showReason(x.user_id,x._id)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Cancel</span>
                          <span v-if="x.status == 'Reschedule Request Pending'" @click="showReason1(x.user_id,x._id,1)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Cancel</span>
                          <span v-if="x.status =='Reschedule Requested' && x.req_new_time !='interviewer'" @click="showReason1(x.user_id,x._id,1)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Decline</span>
                          <span v-if="x.status =='Reschedule Requested' && x.reschedule_by !=null && x.req_new_time =='interviewer'" @click="showReason1(x.user_id,x._id,2)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Decline</span>
                          <span v-if="x.status == 'Reschedule Requested' && x.reschedule_by ==null && x.req_new_time =='interviewer'" @click="showReason1(x.user_id,x._id,3)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Decline</span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
              </div>
              <!-- /.tab-pane -->
            </div>
            <!-- /.tab-content -->
          </div>
          <!-- nav-tabs-custom -->
          <profile-modal v-model="modalOpen" :shwovalueProfileProfile="modalOpen" v-if="modalOpen"></profile-modal>
          <schedule-detail v-model="sheduleOpen" :shwovalueScheduleDetails="sheduleOpen" v-if="sheduleOpen"></schedule-detail>
          <reason-popup v-model="reasonOpen" :shwovalueReason="reasonOpen" v-if="reasonOpen"></reason-popup>
          <div class="modal overlay fade in" id="myModal1">
            <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
              <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
                <div class="modal-body" style="padding:0px">
                  <div class="row" >
                    <div class="col-md-12 " style="padding:17px">
                      <div class="col-md-12" style="text-align: center;">
                        <p style="font-size: 20px;font-weight: 400;">{{infoName}}</p><br>
                        <button class="btn btn-success" @click="closeViolated()">Ok</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
          </div>
        </div>
    </div>
</template>
<script>

import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import router from '../../router/index'
import ProfileModal from '../Feature/profileDetails'
import ReasonPopup from '../Feature/reasonpopup'
import ScheduleDetail from '../Feature/scheduledetail'
// import StarRating from 'vue-star-rating'
import Vue from 'vue'
import moment from 'moment'
// import AgoraRTC from 'agora-rtc-sdk'
import * as Cookies from 'js-cookie'
import $ from 'jquery'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import momentsone from 'moment-timezone'
import CardView from '../Feature/cardView'
Vue.use(moment)
export const EventBus = new Vue()
const clickHandler = function (userid) {
  console.log(`Oh, that's nice. It's gotten ${userid} clicks! :)`)
}
const formShape = {
  reason: '',
  comments: ''
}
// Listen to the event.
EventBus.$on('i-got-clicked', clickHandler)

export default {
  name: 'Shedule',
  data () {
    return {
      viewid: [],
      form: Object.assign({}, formShape),
      job_title: '',
      job_skills: '',
      job_validity: '',
      job_postedon: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      interestedsend: [],
      datas: [],
      releventprofiles: [],
      interested: [],
      postdatas: [],
      bothinterest: [],
      availabledate: [],
      groupeddate: [],
      availabletime: [],
      startdatetime: '',
      enddatetime: '',
      selectdate: '',
      mainurl: '',
      base_urls: BaseURL,
      postsearch: '',
      postsort: 7,
      datassShow: 15,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      tabOne: false,
      tabTwo: false,
      tabThree: false,
      tabFour: false,
      tabFive: false,
      tabSix: false,
      showfiletersend: true,
      showfileterreceive: false,
      selectpost: '',
      timezone: momentsone.tz.guess(),
      sheduledatas: [],
      modalOpen: false,
      sheduleOpen: false,
      reasonOpen: false,
      intestpoput: false,
      validationerror: false,
      showtime: false,
      isLoading: true,
      fullPage: true,
      showRole: false,
      selecttimedetais: [],
      reasonList: [],
      profileid: '',
      actiontype: '',
      selectdata: JSON.parse(localStorage.getItem('postId')),
      releventprofileslength: 0,
      showre_date_error: false,
      showre_time_error: false,
      retime: 0,
      redate: 0,
      reschedule_type: 'normal',
      infoName: '',
      current_date: '',
      timezoneApp: '',
      currentTimeZone: momentsone.tz.guess()
    }
  },
  components: {
    ScheduleDetail, ProfileModal, ReasonPopup, Loading, CardView
  },
  created () {
    this.tabOne = true
    this.config = {
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      }
    }
    this.getDatas()
    this.getreasondata()
    this.$root.$emit('navigate', 'Scheduled')
    var time = new Date()
    var timeZoneOffset = time.getTimezoneOffset()
    this.timezoneApp = moment.tz.zone(this.currentTimeZone).abbr(timeZoneOffset)
    this.currentTimezone = this.timezoneApp
    if (this.timezoneApp === 'EDT') {
      this.timezoneApp = 'EST'
    } else if (this.timezoneApp === 'PDT') {
      this.timezoneApp = 'PST'
    } else if (this.timezoneApp === 'AKDT') {
      this.timezoneApp = 'AHST'
    }
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      this.showRole = true
    }
  },
  mounted () {
    this.$root.$on('message_from_tobe', (arg) => {
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      this.getpostdata(arg)
      this.getReleventProfile(arg, '')
      this.getDatas()
    })
    this.$root.$on('message_cancel', (arg, id) => {
      this.selectpost = id
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      this.showReasonfromdetail(arg)
    })
    this.$root.$on('message_reschedule', (id, arg) => {
      this.selectpost = arg.post_id
      this.sheduledatas = arg
      this.getavailabledate(id, arg)
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
    })
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      reason: {
        required
      },
      comments: {
        required
      }
    }
  },
  methods: {
    openInfo (x) {
      if (x.interviewer_accept === 'yes' && x.status === 'Accepted') {
        this.infoName = x.first_name + ' ' + x.last_name
        this.infoName = this.infoName + ' has accepted the schedule'
      } else if (x.interviewer_cancel === 'yes' && x.status === 'Declined') {
        this.infoName = x.first_name + ' ' + x.last_name
        this.infoName = this.infoName + ' has declined the schedule'
      } else if (x.candidate_accept === 'yes' && x.status === 'Accepted') {
        this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = this.infoName + ' has accepted the schedule'
      } else if (x.candidate_cancel === 'yes' && x.status === 'Declined') {
        this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = this.infoName + ' has declined the schedule'
      } else if (x.status === 'Auto-Declined') {
        // this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = 'Schedule has been auto declined since the interviewer’s calendar has been blocked for another interview.'
      }
      $('#myModal1').modal('show')
    },
    closeViolated () {
      $('#myModal1').modal('hide')
    },
    getDate (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('DD MMM YYYY')
      return Start
    },
    getTime (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('hh:mm a')
      return Start
    },
    updateinterestcount (type, intid) {
      const id = this.userInfo._id
      axios.get(BaseURL + '/dashboard/update_notification/web/' + id + '/' + this.selectpost + '/' + type, this.config).then(response => {
        this.reloaddata()
      }).catch(e => {
      })
    },
    reloaddata () {
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      if (this.postsearch) {
        this.mainurl = '/dashboard/get_schedule_post_list/web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
      } else {
        this.mainurl = '/dashboard/get_schedule_post_list/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
      }
      axios.get(`${this.base_urls}${this.mainurl}`, this.config).then(response => {
        this.datas = response.data.postDetails
      }).catch(e => {
        console.log(e)
      })
    },
    checkingdate (date, end) {
      var currentDate = new Date()
      this.current_date = moment(String(currentDate)).utc().format('YYYYMMDDHHmm')
      var scheduledate = moment.utc(date).subtract(5, 'minutes').toDate()
      scheduledate = moment.utc(scheduledate).format('YYYYMMDDHHmm')
      var endtime = moment.utc(end).format('YYYYMMDDHHmm')
      if (this.current_date >= scheduledate && this.current_date < endtime) {
        return 'yes'
      } else {
        return 'no'
      }
    },
    getreasondata () {
      axios.get(this.base_urls + '/dashboard/get_cancel_reason/web', this.config).then(response => {
        this.reasonList = response.data.reasonlist
      }).catch(e => {
      })
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    connect (id, sid, viewid, x) {
      Cookies.set('channel', id)
      Cookies.set('sid', sid)
      Cookies.set('type', 1)
      localStorage.setItem('type', 1)
      Cookies.set('baseMode', 'avc')
      Cookies.set('transcode', 'interop')
      Cookies.set('attendeeMode', 'video')
      Cookies.set('videoProfile', '480p_4')
      localStorage.setItem('job_title', x.job_tittle)
      localStorage.setItem('organization', this.userInfo.organization)
      router.push('/agora/meeting')
    },
    getReleventProfile (id, val) {
      if (val !== 'no') {
        this.selectdata = val
      }
      if (id === undefined || id === 'undefined') {
        return false
      }
      this.selectpost = id
      const mainurl = '/dashboard/get_schedule_user_list/web/' + id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.releventprofiles = response.data.postDetails
        this.releventprofileslength = this.releventprofiles.length
        this.updateinterestcount('schedule', '1')
      }).catch(e => {
        console.log(e)
      })
    },
    close () {
      this.intestpoput = false
      this.validationerror = false
    },
    reSchedule () {
      if (this.reschedule_type === 'normal') {
        if (this.validate()) {

        } else {
          return false
        }
      }
      if (this.redate === 0) {
        this.showre_date_error = true
        return false
      }
      if (this.redate === 1) {
        if (this.retime === 0) {
          this.showre_time_error = true
          return false
        }
      }
      let postdatas = []
      postdatas = {
        _id: this.sheduledatas._id,
        org_id: this.userInfo._id,
        schedule_date: moment(this.selecttimedetais.startdate).format('Y-MM-DD'),
        schedule_start_time: moment('19 Oct 2017 ' + this.selecttimedetais.start_time).format('HH:mm:ss'),
        schedule_end_time: moment('19 Oct 2017 ' + this.selecttimedetais.end_time).format('HH:mm:ss'),
        start_datetime: moment(this.selecttimedetais.start_datetime).format('Y-MM-DD HH:mm:ss'),
        end_datetime: moment(this.selecttimedetais.end_datetime).format('Y-MM-DD HH:mm:ss'),
        reschedule_reason_comments: this.form.comments,
        reschedule_reason_id: this.form.reason,
        reschedule_reason_name: $('#reason option:selected').text()
      }
      var mainurl = ''
      if (this.reschedule_type === 'normal') {
        if (this.showRole) {
          mainurl = '/dashboard/reschedule_acs/web'
        } else {
          mainurl = '/dashboard/reschedule/web'
        }
        // mainurl = '/dashboard/reschedule/web'
      } else if (this.reschedule_type === 'newtime1') {
        mainurl = '/dashboard/add_schedule_req_newtime'
      } else if (this.reschedule_type === 'reschedule_request') {
        mainurl = '/dashboard/reschedule_accept/' + this.sheduledatas._id
      } else {
        mainurl = '/dashboard/request_newtime_schedule'
      }
      axios.post(`${this.base_urls}${mainurl}`, { formData: postdatas }, this.config).then(response => {
        this.intestpoput = false
        this.getReleventProfile(this.selectpost, 'no')
      }).catch(e => {
        console.log(e)
      })
    },
    rescheduleaccept (id, user) {
      axios.get(this.base_urls + '/dashboard/reschedule_accept/' + id, this.config).then(response => {
        this.getReleventProfile(this.selectpost, 'no')
      })
    },
    getdatetime (start, end) {
      this.retime = 1
      this.showre_time_error = false
      this.selecttimedetais = start
    },
    changeDate (date) {
      if (date === this.selectdate) {
        console.log('same')
      } else {
        this.selecttimedetais = null
        this.retime = 0
      }
      this.selectdate = date
      this.redate = 1
      this.showre_date_error = false
      this.showtime = true
      this.groupTime(this.availabledate, this.selectdate)
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          this.groupeddate.push(item)
        }
      })
    },
    groupTime (array, key) {
      this.availabletime = []
      let k = 0
      for (k = 0; k < this.availabledate.length; k++) {
        if (this.availabledate[k].startdate === key) {
          this.availabletime.push(this.availabledate[k])
        }
      }
    },
    getavailabledateEmit (data) {
      this.getavailabledate(data.id, data.data)
    },
    getavailabledate (id, data) {
      if (data.req_new_time === 'interviewer' && data.status !== 'reschedule') {
        this.reschedule_type = 'newtime'
      } else if (data.req_new_time === 'interviewer' && data.status === 'reschedule') {
        this.reschedule_type = 'newtime1'
      } else if (data.status === 'Reschedule Requested') {
        this.reschedule_type = 'reschedule_request'
      } else {
        this.reschedule_type = 'normal'
      }
      this.sheduledatas = data
      this.availabledate = []
      this.groupeddate = []
      this.showtime = false
      this.profileid = id
      const mainurl = '/dashboard/get_user_availability/web/' + id
      this.intestpoput = true
      this.$v.$reset()
      this.form.reason = ''
      this.form.comments = ''
      this.validationerror = false
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.availabledate = response.data.availabilityDetails
        this.groupBy(this.availabledate, 'startdate')
        this.getReleventProfile(this.sheduledatas.post_id, 'no')
      }).catch(e => {
        console.log(e)
      })
    },
    showModal (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.modalOpen = true
    },
    showShedule (id, userid) {
      this.viewid = userid
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      localStorage.setItem('sid', JSON.stringify(id))
      this.sheduleOpen = true
    },
    showReason (id, sid) {
      this.viewid = id
      localStorage.setItem('sid', JSON.stringify(sid))
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.reasonOpen = true
    },
    showReasonfromdetail (id) {
      this.viewid = id
      // localStorage.setItem('sid', JSON.stringify(sid))
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.reasonOpen = true
    },
    showReason1 (id, sid, type) {
      this.viewid = id
      if (type === 2) {
        localStorage.setItem('reschedule', JSON.stringify('decline'))
      } else if (type === 3) {
        localStorage.setItem('reschedule', JSON.stringify('decline1'))
      } else {
        localStorage.setItem('reschedule', JSON.stringify('cancel'))
      }
      localStorage.setItem('sid', JSON.stringify(sid))
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.reasonOpen = true
    },
    getDatas () {
      if (this.postsearch) {
        this.mainurl = '/dashboard/get_schedule_post_list/web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
      } else {
        this.mainurl = '/dashboard/get_schedule_post_list/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
      }
      axios.get(`${this.base_urls}${this.mainurl}`, this.config).then(response => {
        this.datas = response.data.postDetails
        this.isLoading = false
        if (this.selectdata !== 'no' && this.selectdata !== '' && this.selectdata !== null) {
          if (this.selectdata._id === undefined) {
            this.selectpost = this.selectdata.post_id
            this.getReleventProfile(this.selectpost, this.selectdata)
          } else {
            this.selectpost = this.selectdata._id
            this.getReleventProfile(this.selectpost, this.selectdata)
          }
        } else {
          this.selectpost = this.datas[0]._id
          this.selectdata = this.datas[0]
          this.getReleventProfile(this.selectpost, this.selectdata)
        }
        if (!this.datas.some(data => data._id === this.selectpost)) {
          this.selectpost = this.datas[0]._id
          this.selectdata = this.datas[0]
          this.getReleventProfile(this.selectpost, this.selectdata)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getpostdata () {
      const mainurl = '/dashboard/get_post_details/ios/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.selectdata = response.data.interviewerList[0]
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    }
  }
}
</script>

<style scoped>
.f11 {
  font-size: 11px;
}
select.is-invalid {
  border-color: #f86c6b !important;
}
.tabs.is-centered.is-fullwidth {
  margin-bottom: 0px;
}
ul {
    margin-bottom: 0;
    padding-bottom: 0;
}
.box___border {
  border-style: solid;
  border-width: 0px 0px 0px 0px;
  border-bottom-color: #98a2ac;
  border-right-color: #98a2ac;
  border-left-color: #98a2ac;
}
.navigation-tabs.full-pills .tabs ul {
  padding-bottom: 0px;
  border-bottom: 0px solid #fff !important;
}

.is-active {
    background-color: #fff;
}

.tabs ul li {
    text-align: center;
    padding: 9px;
    background-color: #f9f9f9;
    cursor: pointer;
}
li.green-tab.is-active {
  border-style: solid;
  border-width: 4px 0px 0px 0px;
  border-top-color: rgb(91, 173, 43);
  border-right-color: #98a2ac;
  border-left-color: #98a2ac;
}
.posttab li.green-tab.is-active {
  border-style: solid;
  border-width: 4px 0px 0px 0px;
  border-top-color: rgb(91, 173, 43);
  background: #5bad2b;
  color: #fff;
}
.flex-card .card-body.is-small {
  /* padding-right: 15px !important;
  padding-bottom: 15px !important;
  padding-left: 15px !important; */
  padding: 10px 0px;
}

.ul-padding {
  padding-top: 0px !important;
}

ol,
ul,
dl {
  margin-bottom: 0px;
}
li {
  border-bottom: 1px solid #ededed;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #fff;
}
.user-list li:hover {
  cursor: pointer;
  background-color: #f9f9f9;
  cursor: pointer;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #5BAD2B;
}
.user-list li.is-active {
  cursor: pointer;
  background-color: #f9f9f9;
  cursor: pointer;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #5BAD2B;
}
.pading-top-only {
  padding: 0px 18px 15px;
}
.flex-card.light-bordered.raised {
    box-shadow: none;
}
.flex-card.is-active .name {
    color: #23282c !important;
}
.view-all-btn {
  border: 1px solid #5BAD2B;
  padding: 9px;
}
.card-body li {
  border-bottom: 1px solid #ededed;
}
.view-all-btn {
    border: 1px solid #bfc1c7e8;
    padding: 5px;
}

.posttab ul li {
  padding: 4px;
}
.unintrest {
    border-color: #c8ced3;
    background-color: #ededed73 !important;
    color: #23282c !important;
}
.unintrest :hover {
  border-color: #5BAD2B;
  background-color: #5BAD2B;
  color: #fff;
}
input[type=radio]:checked + label {
  color: #f00;
  font-style: normal;
}

.posttab .tabs ul li[data-v-6e981812] {
    text-align: center;
    padding: 9px;
    background-color: #f9f9f9;
    cursor: pointer;
    border: 1px solid #ccc !important;
}
option:hover{

    background-color:white;
    color: black;

}
.img-avatar {
  width: 100%;
  height: 100%;
}
.profilename:hover {
  color:#5BAD2B;
}
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      max-height: calc(100vh - 40px);
      width: 501px;
  }
}
body.modal {
    overflow: hidden !important;
}
.selectdate {
  border: 1px solid #ccc;
}
.selectdate .txt {
  font-size: 12px;
  color: #73818f !important;
}
.post_interview-type {
  /* background-color: #5BAD2B !important;
  color: #fff !important;
  border: 1px solid #5BAD2B !important; */
  background-color: #fff !important;
  color: #656565 !important;
  border: 1px solid #c8ced3 !important;
}
.interview-type {
  height: 38px;
  text-align: center;
  padding: 0px !important;
  font-weight: 200;
  font-size: 12px;
  width: 47% !important;
  margin: 0px 15px;
  cursor: pointer;
}

.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now label,
.donate-now input {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.donate-now input[type="radio"] {
  opacity: 0.01;
  z-index: 100;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.card-body li {
    border-bottom: 0px;
}
.user-list li {
  border-bottom: 1px solid #ccc;
}
.remove-pad {
  padding-right: 0px;
  padding-left: 0px;
  border-right: 1px solid #d8d7d794;
  height: auto;
  min-height: 700px;
}
.nav-tabs-custom>.tab-content {
  padding: 0px;
  margin-top: 10px;
}
a {
    color: #333;
}
.tab-content {
  background-color: white;
  height: 100% !important;
  min-height: 700px;
  display: flow-root;
}
.box-header.with-border {
    border: 1px solid #d8d7d794;
}
.filterdrop {
  height: 29px;
  font-size: 12px !important;
}
.direct-chat-msg {
    margin-bottom: 0px;
}
.btns {
  background-color: white;
  color: #5bad2b;
}
.post li a {
  line-height: 15% !important;
}
.post.nav-tabs li {
  width: auto;
}
.post li {
  border-width: 0 0 0 0px !important;
}
.nav-tabs.post>li>a:hover {
    border-color: #f5f5f5 #f5f5f5 #f5f5f5 !important;
}
.posttab ul {
  background-color: #f5f5f5 !important;
}

.post li.active a{
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.ml8 {
  margin-left: 8px !important;
}
.direct-chat-messages {
  height: auto !important;
  border-bottom: 1px solid #cccccc73;
}
.direct-chat-messages:hover {
  border-left: 3px solid #5bad2b;
  background-color: #cccccc24;
}
.product-info {
  margin-top: 5px;
}
.btn-group {
  margin-right: 5px;
}
.btn-group {
  margin-right: 5px;
}
select.input-sm {
    height: 30px;
    line-height: 17px !important;
    border: 1px solid #88888840;
}
.modal-header {
    padding: 8px;
}
hr {
  margin-top: auto;
  margin-bottom: auto;
}
.box {
  margin-bottom: 0px !important;
}
.rescheduled-l {
  color: rgb(255, 255, 255);
  background-color: rgb(31, 141, 2);
  padding: 1px 8px 0px;
}
.requested-l {
  color: #1F8D02;
  background-color: #F8F8F8;
  padding: 1px 8px 0px;
}
.requested-pending-l {
  color:#42D21E;
  background-color: #F8F8F8;
  padding: 1px 8px 0px;
}
.row {
  margin-right: 0px;
  margin-left: 0px;
}
.bg-status {
  padding: 4px;
  background-color: #f5f5f5;
}
.box {
  box-shadow: 0 1px 1px rgb(255, 255, 255) !important;
}
textarea.is-invalid {
  border: 1px solid red !important;
}
</style>
